import React, { Component } from 'react'
import actions from './actions'
import { connect } from 'react-redux'
// import { StyleSheet } from 'react-native'
import { Menu, List } from 'react-native-paper'
import { Hoverable } from 'react-native-web-hover'

// const styles = StyleSheet.create({})

class SingleSelect extends Component {
  state = {
    visible: false,
  }

  componentWillMount() {
    // TODO maybe later only on open if more designs
    if (!this.props.list.loadedList) {
      this.props.loadList()
    }
  }

  _open = () => {
    this.setState({ visible: true })
  }
  _close = () => {
    this.setState({ visible: false })
  }
  _change = (item) => () => {
    this.props.onChange(item)
    this._close()
  }

  render() {
    const { value, list, label, description } = this.props
    return (
      <Menu
        visible={this.state.visible}
        onDismiss={this._close}
        anchor={
          <Hoverable key={`design_single_select_${Math.random()}`}>
            {({ hovered }) => (
              <List.Item
                title={
                  value
                    ? value.name
                    : `Geen ${label.toLowerCase()} geselecteerd`
                }
                style={
                  hovered ? { cursor: 'pointer' } : { backgroundColor: '#FFF' }
                }
                testID={this.props.testID}
                description={description}
                onPress={this._open}
                right={(iProps) => (
                  <List.Icon {...iProps} icon={'chevron-down'} />
                )}
              />
            )}
          </Hoverable>
        }
      >
        {(list.data || []).map((item) => {
          return (
            <Menu.Item
              key={item.id}
              testID={'designOption'}
              onPress={this._change(item)}
              title={item.formalName}
            />
          )
        })}
      </Menu>
    )
  }
}

const mapStateToProps = (state) => ({
  list: state.mailDesign.list,
})

export default connect(mapStateToProps, actions)(SingleSelect)
